import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditItemView from "../common/components/EditItemView";
import LinkField from "../common/components/LinkField";

const roles = [
  "superadmin",
  "admin",
  "controle",
  "magasin",
  "consultant",
  "operateur",
];

const UserPage = () => {
  const [item, setItem] = useState(null);

  // Validation simple
  const validate = () => item && item.email && item.username && item.role && item.matricule;

  return (
    <EditItemView
      endpoint="users"
      item={item}
      setItem={setItem}
      validate={validate}
    >
      {item && (
        <>
          {/* 🔹 Infos principales */}
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">Informations principales</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                label="Username"
                value={item.username || ""}
                onChange={(e) => setItem({ ...item, username: e.target.value })}
              />

              <TextField
                label="Matricule"
                value={item.matricule || ""}
                onChange={(e) => setItem({ ...item, matricule: e.target.value })}
              />

              <TextField
                label="Email"
                value={item.email || ""}
                onChange={(e) => setItem({ ...item, email: e.target.value })}
              />

              <TextField
                type="password"
                label="Password"
                onChange={(e) => setItem({ ...item, password: e.target.value })}
              />

              <FormControl fullWidth>
                <InputLabel>Role</InputLabel>
                <Select
                  value={item.role || ""}
                  onChange={(e) => setItem({ ...item, role: e.target.value })}
                >
                  {roles.map((r) => (
                    <MenuItem key={r} value={r}>
                      {r}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </AccordionDetails>
          </Accordion>

          {/* 🔹 Créé / Modifié par */}
          {item._id && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1">Audit</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  label="Créé par"
                  value={item.created_by?.username || ""}
                  disabled
                />
                <TextField
                  label="Modifié par"
                  value={item.modified_by?.username || ""}
                  disabled
                />
                <TextField
                  label="Créé le"
                  value={item.createdAt ? new Date(item.createdAt).toLocaleString() : ""}
                  disabled
                />
                <TextField
                  label="Modifié le"
                  value={item.updatedAt ? new Date(item.updatedAt).toLocaleString() : ""}
                  disabled
                />
              </AccordionDetails>
            </Accordion>
          )}

      
        </>
      )}
    </EditItemView>
  );
};

export default UserPage;
